// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".funnel-dropoff-container{\n    border-left: 1px solid var(--color-secondary);\n}", "",{"version":3,"sources":["webpack://./src/pages/Funnels/CreateFunnel/components/EventCondition/EventCondition.css"],"names":[],"mappings":"AAAA;IACI,6CAA6C;AACjD","sourcesContent":[".funnel-dropoff-container{\n    border-left: 1px solid var(--color-secondary);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
